import React from 'react';
import PropTypes from 'prop-types';

import Container from '@Theme/hellofinance/components/Container/Container';

import * as styles from './Map.module.scss';

const propTypes = {
  /**
   * Embed code of map displayed in module
   */
  embed: PropTypes.string
};

const Map = ({
  embed
}) => {
  if (!embed) {
    return false;
  }

  return (
    <section className={styles.root}>
      <Container>
        <div className={styles.rootMap} dangerouslySetInnerHTML={{
          __html: embed
        }}/>
      </Container>
    </section>
  );
};

Map.propTypes = propTypes;

export default Map;
